import { Injectable } from '@angular/core';
import { FroalaEditorOptions, FroalaSettings } from '@r1-compass-library/models';

@Injectable({
    providedIn: 'root',
})
export class FroalaSettingsService {
    public addBaseSettings(froalaOptions: FroalaEditorOptions): FroalaEditorOptions {
        froalaOptions = {
            ...FroalaSettings.generalOptions.base,
            ...froalaOptions,
        };
        froalaOptions.pluginsEnabled = [...(froalaOptions.pluginsEnabled ?? []), ...FroalaSettings.plugins.base];
        return froalaOptions;
    }

    public addContentSettings(froalaOptions: FroalaEditorOptions): FroalaEditorOptions {
        froalaOptions = {
            ...FroalaSettings.generalOptions.content,
            ...froalaOptions,
        };
        froalaOptions.pluginsEnabled = [...(froalaOptions.pluginsEnabled ?? []), ...FroalaSettings.plugins.content];
        froalaOptions.toolbarButtons = [
            ...(froalaOptions.toolbarButtons ?? []),
            ...FroalaSettings.toolbarButtons.content,
        ];
        return froalaOptions;
    }

    public addImageSettings(froalaOptions: FroalaEditorOptions): FroalaEditorOptions {
        froalaOptions = {
            ...FroalaSettings.generalOptions.image,
            ...froalaOptions,
        };
        froalaOptions.pluginsEnabled = [...(froalaOptions.pluginsEnabled ?? []), ...FroalaSettings.plugins.image];
        froalaOptions.htmlAllowedAttrs =
            froalaOptions.htmlAllowedAttrs ?? FroalaSettings.generalOptions.image?.htmlAllowedAttrs;
        froalaOptions.toolbarButtons = [
            ...(froalaOptions.toolbarButtons ?? []),
            ...FroalaSettings.toolbarButtons.image,
        ];
        return froalaOptions;
    }

    public addTableSettings(froalaOptions: FroalaEditorOptions): FroalaEditorOptions {
        froalaOptions = {
            ...FroalaSettings.generalOptions.table,
            ...froalaOptions,
        };
        froalaOptions.pluginsEnabled = [...(froalaOptions.pluginsEnabled ?? []), ...FroalaSettings.plugins.table];
        froalaOptions.toolbarButtons = [
            ...(froalaOptions.toolbarButtons ?? []),
            ...FroalaSettings.toolbarButtons.table,
        ];
        return froalaOptions;
    }
}
